export default __webpack_public_path__ + "static/media/reunit.4f02f61a.png";